/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_seo_fr_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Find and Replace`)
};

const es_home_seo_fr_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abre Buscar y Reemplazar`)
};

const de_home_seo_fr_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchen und Ersetzen öffnen`)
};

const nl_home_seo_fr_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Zoeken en vervangen`)
};

const fr_home_seo_fr_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir Chercher et Remplacer`)
};

const it_home_seo_fr_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri Cerca e Sostituisci`)
};

const pt_br2_home_seo_fr_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir Localizar e Substituir`)
};

const pt_home_seo_fr_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir Procurar e Substituir`)
};

const ja_home_seo_fr_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索と置換を開く`)
};

const zh_home_seo_fr_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开查找和替换`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_seo_fr_cta = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_seo_fr_cta(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_seo_fr_cta", locale)
	if (locale === "en") return en_home_seo_fr_cta(inputs)
	if (locale === "es") return es_home_seo_fr_cta(inputs)
	if (locale === "de") return de_home_seo_fr_cta(inputs)
	if (locale === "nl") return nl_home_seo_fr_cta(inputs)
	if (locale === "fr") return fr_home_seo_fr_cta(inputs)
	if (locale === "it") return it_home_seo_fr_cta(inputs)
	if (locale === "pt-BR") return pt_br2_home_seo_fr_cta(inputs)
	if (locale === "pt") return pt_home_seo_fr_cta(inputs)
	if (locale === "ja") return ja_home_seo_fr_cta(inputs)
	return zh_home_seo_fr_cta(inputs)
};